/* ═══════════════════════════════════════════════════════════
   RAREITEM — หน้าผลการค้นหา (Thai Search)
   - ดึงผลจาก Thai Search Worker (จัดอันดับ: ขึ้นต้น → ทั้งคำ → กลางคำ,
     ค้นจาก ชื่อ/variant/SKU/tag/type/collection) แล้ว render แทนผล Shopify
   - ตัวกรอง: หมวดสินค้า / ช่วงราคา / เฉพาะพร้อมส่ง + แบ่งหน้า (ฝั่ง client)
   - Worker ล่มหรือช้าเกิน 3 วิ → ไม่แตะอะไรเลย ผลค้นหาปกติของ Shopify
     ที่ server render มาแล้วยังแสดงตามเดิม (fallback ในตัว)
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var root = document.getElementById('SearchPage');
  if (!root) return;
  var workerUrl = (root.getAttribute('data-thai-search') || '').replace(/\/+$/, '');
  var q = (root.getAttribute('data-query') || '').trim();
  if (!workerUrl || !q || q.replace(/\*/g, '').trim() === '') return;

  var moneyFormat = root.getAttribute('data-money-format') || '';
  var allUrl = root.getAttribute('data-all-url') || '/collections/all';
  var shopifyResults = document.getElementById('ShopifySearchResults');
  var host = document.getElementById('ThaiSearchResults');
  var countEl = document.getElementById('SearchResultCount');
  if (!host) return;

  var PER_PAGE = 24;
  var state = { all: [], filtered: [], page: 1, cat: '', min: null, max: null, inStock: false };

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function money(amountStr) {
    var n = parseFloat(amountStr);
    if (isNaN(n)) return esc(amountStr);
    var display = n % 1 === 0
      ? n.toLocaleString('en-US')
      : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (moneyFormat) return esc(moneyFormat.replace(/{{\s*amount[^}]*}}/g, display));
    return esc(display);
  }

  function imgUrl(u, w) {
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  /* ── ดึงผลจาก Worker (ครั้งเดียว แล้วกรอง/แบ่งหน้าในเครื่อง) ── */
  var controller = new AbortController();
  var timeout = setTimeout(function () { controller.abort(); }, 3000);
  fetch(workerUrl + '/search?q=' + encodeURIComponent(q) + '&limit=100&full=1&instock=1', { signal: controller.signal })
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function (data) {
      clearTimeout(timeout);
      if (!data || !data.ok || !Array.isArray(data.results)) return;
      state.all = data.results;
      if (shopifyResults) shopifyResults.hidden = true;
      host.hidden = false;
      build();
    })
    .catch(function () {
      clearTimeout(timeout); /* คงผล Shopify เดิมไว้ — ลูกค้าไม่เห็นความต่าง */
    });

  /* ── โครงหน้า ── */
  function build() {
    if (!state.all.length) {
      if (countEl) countEl.textContent = 'พบ 0 รายการ';
      host.innerHTML =
        '<div class="cart-empty">' +
          '<p>ไม่พบสินค้าที่ตรงกับ “' + esc(q) + '” — ลองคำสั้นกว่านี้ หรือดูสินค้าทั้งหมด</p>' +
          '<a href="' + esc(allUrl) + '" class="btn btn-primary">ดูสินค้าทั้งหมด</a>' +
        '</div>';
      return;
    }

    var cats = [];
    state.all.forEach(function (r) {
      (r.collections || []).forEach(function (c) {
        if (cats.indexOf(c) < 0) cats.push(c);
      });
    });
    cats.sort(function (a, b) { return a.localeCompare(b, 'th'); });

    host.innerHTML =
      '<div class="tsp-filters" role="group" aria-label="ตัวกรองผลการค้นหา">' +
        '<select id="TspCat" aria-label="กรองตามหมวดสินค้า">' +
          '<option value="">ทุกหมวดสินค้า</option>' +
          cats.map(function (c) { return '<option value="' + esc(c) + '">' + esc(c) + '</option>'; }).join('') +
        '</select>' +
        '<span class="tsp-price">' +
          '<input type="number" id="TspMin" min="0" inputmode="numeric" placeholder="ราคาต่ำสุด ฿" aria-label="ราคาต่ำสุด">' +
          '<span aria-hidden="true">–</span>' +
          '<input type="number" id="TspMax" min="0" inputmode="numeric" placeholder="ราคาสูงสุด ฿" aria-label="ราคาสูงสุด">' +
        '</span>' +
        '<label class="tsp-stock"><input type="checkbox" id="TspStock"> เฉพาะพร้อมส่ง</label>' +
      '</div>' +
      '<div class="grid-3" id="TspGrid" style="padding-bottom:20px"></div>' +
      '<nav class="tsp-pages" id="TspPages" aria-label="หน้าผลการค้นหา"></nav>';

    document.getElementById('TspCat').addEventListener('change', function () {
      state.cat = this.value; state.page = 1; apply();
    });
    var priceTimer = null;
    function onPrice() {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () {
        var min = parseFloat(document.getElementById('TspMin').value);
        var max = parseFloat(document.getElementById('TspMax').value);
        state.min = isNaN(min) ? null : min;
        state.max = isNaN(max) ? null : max;
        state.page = 1; apply();
      }, 300);
    }
    document.getElementById('TspMin').addEventListener('input', onPrice);
    document.getElementById('TspMax').addEventListener('input', onPrice);
    document.getElementById('TspStock').addEventListener('change', function () {
      state.inStock = this.checked; state.page = 1; apply();
    });

    apply();
  }

  /* ── กรอง + นับ + วาด ── */
  function apply() {
    state.filtered = state.all.filter(function (r) {
      if (state.cat && (r.collections || []).indexOf(state.cat) < 0) return false;
      var p = parseFloat(r.price);
      if (state.min !== null && (isNaN(p) || p < state.min)) return false;
      if (state.max !== null && (isNaN(p) || p > state.max)) return false;
      if (state.inStock && r.available === false) return false;
      return true;
    });

    if (countEl) {
      countEl.textContent = 'พบ ' + state.filtered.length + ' รายการ' +
        (state.filtered.length !== state.all.length ? ' (กรองจากทั้งหมด ' + state.all.length + ')' : '');
    }

    var pages = Math.max(1, Math.ceil(state.filtered.length / PER_PAGE));
    if (state.page > pages) state.page = pages;
    renderGrid();
    renderPages(pages);
  }

  function renderGrid() {
    var grid = document.getElementById('TspGrid');
    var slice = state.filtered.slice((state.page - 1) * PER_PAGE, state.page * PER_PAGE);

    if (!slice.length) {
      document.getElementById('TspPages').innerHTML = '';
      grid.innerHTML =
        '<div class="cart-empty" style="grid-column:1/-1">' +
          '<p>ไม่มีสินค้าตรงกับตัวกรองที่เลือก — ลองปรับตัวกรอง หรือดูสินค้าทั้งหมด</p>' +
          '<a href="' + esc(allUrl) + '" class="btn btn-primary">ดูสินค้าทั้งหมด</a>' +
        '</div>';
      return;
    }

    grid.innerHTML = slice.map(function (r) {
      var sale = r.compare_at_price && parseFloat(r.compare_at_price) > parseFloat(r.price);
      var pct = sale
        ? Math.round((parseFloat(r.compare_at_price) - parseFloat(r.price)) * 100 / parseFloat(r.compare_at_price))
        : 0;
      return (
        '<article class="pcard' + (r.available === false ? ' is-out' : '') + '">' +
          '<a href="' + esc(r.url) + '" class="pimg" tabindex="-1" aria-hidden="true">' +
            (r.image
              ? '<img src="' + esc(imgUrl(r.image, 600)) + '" loading="lazy" alt="">'
              : '<span class="tsp-noimg" aria-hidden="true"></span>') +
            (sale && r.available !== false ? '<span class="offtag">-' + pct + '%</span>' : '') +
            (r.available === false ? '<span class="outveil"><span>สินค้าหมด</span></span>' : '') +
          '</a>' +
          '<div class="body">' +
            '<h3 class="name"><a href="' + esc(r.url) + '">' + esc(r.title) + '</a></h3>' +
            '<div class="price">' +
              (sale
                ? '<span class="now">' + money(r.price) + '</span><span class="was">' + money(r.compare_at_price) + '</span>'
                : '<span class="now now--regular">' + money(r.price) + '</span>') +
            '</div>' +
            '<a href="' + esc(r.url) + '" class="btn btn-accent btn-sm qadd btn-block">ดูสินค้า</a>' +
          '</div>' +
        '</article>'
      );
    }).join('');
  }

  function renderPages(pages) {
    var nav = document.getElementById('TspPages');
    if (pages <= 1) { nav.innerHTML = ''; return; }
    var html = '<button type="button" data-page="' + (state.page - 1) + '"' + (state.page === 1 ? ' disabled' : '') + ' aria-label="หน้าก่อนหน้า">‹</button>';
    for (var i = 1; i <= pages; i++) {
      html += '<button type="button" data-page="' + i + '"' + (i === state.page ? ' aria-current="page"' : '') + '>' + i + '</button>';
    }
    html += '<button type="button" data-page="' + (state.page + 1) + '"' + (state.page === pages ? ' disabled' : '') + ' aria-label="หน้าถัดไป">›</button>';
    nav.innerHTML = html;
    nav.querySelectorAll('button[data-page]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = parseInt(this.getAttribute('data-page'), 10);
        if (isNaN(p) || p < 1) return;
        state.page = p;
        apply();
        host.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
})();
